import React from 'react';
import { useDispatch } from 'react-redux';
import { LessonTypes } from 'store/modules/course_store/types';
import { ProgressionCoursesTypes } from 'store/modules/progression_course_store/types';
import { getDataCourse, mark_as_done } from 'store/modules/course_store/actions';
import RadioButtonSelect from '../radio_button_select';

interface LessonItemProps {
  lesson: LessonTypes;
  scrollToVideo: () => void;
}

const LessonItem: React.FC<LessonItemProps> = (props: LessonItemProps) => {
  const { lesson, scrollToVideo } = props;
  const dispatch = useDispatch();

  const toggleConcluded = (id: string, updateAll = false) => {
    !updateAll && dispatch(mark_as_done(Number(id)));
    dispatch(getDataCourse(2));
  };

  return (
    <li className="list-group-item border-0 pb-0 bg-transparent" key={lesson?.id}>
      <div className="row">
        <div className="col-10">
          <span className="modulo">
            <button
              type="button"
              className="btn-lesson btn btn-link"
              onClick={() => {
                dispatch({
                  type: ProgressionCoursesTypes.LAST_CLASS,
                  last_class: lesson,
                });

                scrollToVideo();
              }}
            >
              {lesson?.nome}
            </button>
          </span>
        </div>
        <div className="col-2">
          <span className="modulo-count">
            <RadioButtonSelect
              isChecked={lesson?.contact_class_progression[0]?.concluded}
              text={String(lesson?.id)}
              toggleSelectContracts={toggleConcluded}
            />
          </span>
        </div>
      </div>
    </li>
  );
};

export default LessonItem;
